export default __webpack_public_path__ + "static/media/menu.67e3bd3c.svg";